




























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Job } from '@/models/jobDetail/job';
import { JobUserStatusEnum } from '@/types/jobUserStatus';
import Nullable from '@/types/nullable';
import { getStatusName, getStatusColor } from '@/services/jobService';

@Component({})
export default class JobStatusSummary extends Vue {
  @Prop({ type: Object, default: null }) public job: Nullable<Job>;
  private promptTake5Dialog: boolean = false;

  get estimateFriendly() {
    if (this.job.estimateDays) {
      let estimateDays = this.job.estimateDays;

      return `${estimateDays}d`;
    }

    return "";
  }

  changeStatus(){
    if(!this.job.assignment.take5SafetyComplete){
      this.promptTake5Dialog = true;
      return;
    }
    this.$router.push({ name: 'viewjobstatus', params: { jobID: this.job.id } });
  }

  navigateTake5(){
    this.$router.push({ name: 'viewjobtake5', params: { jobID: this.job.id }});
  }

  navigateBack(){
    this.promptTake5Dialog = false;
  }

  get currentStatus(){
    return getStatusName(this.job.assignment.latestStatus.status.id);
  }

  get statusOptions(){
    let statusOptions = [];

    if(this.job.assignment.latestStatus.status.id !== JobUserStatusEnum.FINISH_WORK) {
      statusOptions.push(JobUserStatusEnum.TRAVEL);
      statusOptions.push(JobUserStatusEnum.START_CONTINUE_WORK);
      statusOptions.push(JobUserStatusEnum.NONE_CHARGEABLE);
      statusOptions.push(JobUserStatusEnum.BREAK);
      statusOptions.push(JobUserStatusEnum.DAY_COMPLETE);
      statusOptions.push(JobUserStatusEnum.FINISH_WORK);
    }

    return statusOptions.map(x => {
      return {
        label: getStatusName(x),
        value: x
      }
    });
  }

  get statusColor(){
    return getStatusColor(this.job.assignment.latestStatus.status.id);
  }

  hoursAndMinutes(totalMinutes: number){
    let textParts = [];

    let hours = Math.floor(totalMinutes / 60.0);
    if(hours > 0){
      textParts.push(`${hours}h`);
    }

    let minutes = Math.round(totalMinutes % 60);
    if(minutes > 0){
      textParts.push(`${minutes}m`);
    }

    if(textParts.length == 0){
      return "<1m";
    }

    return textParts.join(" ");
  }

  get hoursWorked(){
    if(this.job.durations.work === 0){
      return null;
    }
    
    return this.hoursAndMinutes(this.job.durations.work / 60);
  }

  get hoursNoneChargeable() {
    if(this.job.durations.noneChargeable === 0){
      return null;
    }
    
    return this.hoursAndMinutes(this.job.durations.noneChargeable / 60);
  }

  get hoursOnBreak(){
    if(this.job.durations.break === 0){
      return null;
    }

    return this.hoursAndMinutes(this.job.durations.break / 60);
  }

  get hoursTravelling(){
    if(this.job.durations.travel === 0){
      return null;
    }

    return this.hoursAndMinutes(this.job.durations.travel / 60);
  }
}

